import { useState, useEffect } from "react";
import api, { formatApiError } from "../../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { toast } from "sonner";

const TYPE_LABELS = { wholesale: "Wholesale", bulk: "Bulk Enquiry", contact: "Contact" };
const STATUSES = ["new", "contacted", "converted", "closed"];

export default function AdminEnquiries() {
  const [enquiries, setEnquiries] = useState(null);
  const [expanded, setExpanded] = useState(null);

  const load = () => api.get("/admin/enquiries").then((r) => setEnquiries(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.put(`/admin/enquiries/${id}`, { status });
      toast.success(`Marked as ${status}`);
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  if (!enquiries) return <div className="h-40 bg-muted animate-pulse" />;

  return (
    <div data-testid="admin-enquiries">
      <h1 className="font-serif text-3xl font-semibold mb-8">Enquiries <span className="text-sm text-muted-foreground font-sans font-normal">({enquiries.length})</span></h1>
      {enquiries.length === 0 ? (
        <p className="text-sm text-muted-foreground bg-white border border-black/10 p-12 text-center" data-testid="no-enquiries">No enquiries yet.</p>
      ) : (
        <div className="flex flex-col gap-3">
          {enquiries.map((e) => (
            <div key={e.id} className="bg-white border border-black/10" data-testid={`enquiry-${e.id}`}>
              <button onClick={() => setExpanded(expanded === e.id ? null : e.id)} className="w-full flex flex-wrap items-center gap-3 p-4 text-left" data-testid={`enquiry-toggle-${e.id}`}>
                <span className={`text-[10px] uppercase tracking-widest px-2 py-1 ${e.type === "contact" ? "bg-muted text-muted-foreground" : "bg-gold-light text-[#111]"}`}>{TYPE_LABELS[e.type] || e.type}</span>
                <span className="font-medium text-sm flex-1">{e.name}</span>
                {e.product_name && <span className="text-xs text-muted-foreground">{e.product_name}</span>}
                <span className="text-xs text-muted-foreground">{new Date(e.created_at).toLocaleDateString("en-IN")}</span>
                <Select value={e.status === "replied" ? "contacted" : e.status} onValueChange={(v) => updateStatus(e.id, v)}>
                  <SelectTrigger className="w-32 h-8 text-[10px] uppercase tracking-widest rounded-sm bg-white" data-testid={`enquiry-status-${e.id}`}><SelectValue /></SelectTrigger>
                  <SelectContent>
                    {STATUSES.map((s) => <SelectItem key={s} value={s} data-testid={`enquiry-status-${s}`}>{s}</SelectItem>)}
                  </SelectContent>
                </Select>
              </button>
              {expanded === e.id && (
                <div className="border-t border-black/10 p-4 text-sm" data-testid={`enquiry-details-${e.id}`}>
                  <p><span className="text-muted-foreground">Email:</span> {e.email} · <span className="text-muted-foreground">Phone:</span> {e.phone}</p>
                  {e.company && <p className="mt-1"><span className="text-muted-foreground">Company:</span> {e.company}</p>}
                  {e.quantity && <p className="mt-1"><span className="text-muted-foreground">Quantity:</span> {e.quantity}</p>}
                  {e.message && <p className="mt-3 bg-muted/50 p-3">{e.message}</p>}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
